import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDaySleetShower: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M83.1539 77.4334L82.1205 74.2556L77.965 75.6112V71.2334H74.6316V75.6112L70.465 74.2556L69.4316 77.4334L73.5983 78.7778L71.0205 82.3112L73.7205 84.2778L76.2983 80.7445L78.865 84.2778L81.565 82.3112L78.9983 78.7778L83.1539 77.4334Z"
        fill="#D2E0FF"
      />
      <path
        d="M73.2319 87.589L69.0763 88.9446V84.5668H65.743V88.9446L61.5763 87.589L60.543 90.7668L64.7096 92.1112L62.1319 95.6557L64.8319 97.6112L67.4096 94.0779L69.9763 97.6112L72.6763 95.6557L70.0985 92.1112L74.2652 90.7668L73.2319 87.589Z"
        fill="#D2E0FF"
      />
      <path
        d="M36.0658 32.8778C37.7658 28.8445 40.5547 25.4667 43.977 22.9001C41.7436 18.6556 37.3436 15.7223 32.2103 15.7223C24.8436 15.7223 18.877 21.689 18.877 29.0556C18.877 33.2001 20.8103 36.8556 23.777 39.3001C26.877 35.8556 31.1881 33.489 36.0658 32.8778Z"
        fill="#F9D23E"
      />
      <path
        d="M34.2207 2.38892H30.2207V12.3889H34.2207V2.38892Z"
        fill="#F9D23E"
      />
      <path
        d="M14.78 8.78549L11.9512 11.6139L19.0222 18.6859L21.851 15.8575L14.78 8.78549Z"
        fill="#F9D23E"
      />
      <path
        d="M15.5547 27.0555H5.55469V31.0555H15.5547V27.0555Z"
        fill="#F9D23E"
      />
      <path
        d="M49.6638 8.78542L42.5938 15.8574L45.4226 18.6854L52.4926 11.6134L49.6638 8.78542Z"
        fill="#F9D23E"
      />
      <path
        d="M21.6995 42.1L19.0217 39.4222L11.9551 46.5L14.7773 49.3222L21.3884 42.7222L21.8551 42.2556L21.6995 42.1Z"
        fill="#F9D23E"
      />
      <path
        d="M61.8542 71.3889L57.0098 84.7111H61.732L66.5875 71.3889H61.8542Z"
        fill="#87D6F8"
      />
      <path
        d="M42.5095 71.3889L40.8984 75.8111H45.6207L47.2318 71.3889H42.5095Z"
        fill="#87D6F8"
      />
      <path
        d="M52.1775 71.3889L50.5664 75.8111H55.2997L56.9109 71.3889H52.1775Z"
        fill="#87D6F8"
      />
      <path
        d="M48.9549 80.2889L47.3438 84.7223H52.066L53.6771 80.2889H48.9549Z"
        fill="#87D6F8"
      />
      <path
        d="M84.2882 47.0445H79.2104V42.1C79.2104 31.1889 70.1104 22.3445 58.8882 22.3445C53.666 22.3445 48.9771 24.3111 45.3993 27.4667C42.4993 30.0223 40.3104 33.3445 39.2993 37.1556H38.5771C34.3438 37.1556 30.5104 38.8445 27.7549 41.5556C25.0326 44.2334 23.3438 47.9111 23.3438 51.9667C23.3438 60.1445 30.166 66.7778 38.5771 66.7778H43.6549H74.1326H84.2882C89.8993 66.7778 94.4438 62.3556 94.4438 56.9C94.4438 51.4667 89.8993 47.0445 84.2882 47.0445Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDaySleetShower
